import { NeoModel, Rules, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class CreateInstrumentTypeCommand extends ValueObject {

    @Rules.Required()
    @Rules.StringLength(100)
    public instrumentTypeName: string = "";
}